import { Chip, FlexBox, Icon, Tooltip } from '@dixa/lib-shared-habla';
import type { SuggestedTag } from 'lib-shared-types-api';

import styles from './suggestedTagChips.module.scss';

type SuggestedTagChipsProps = {
  /** The suggested tags. */
  suggestions: readonly SuggestedTag[];
  /** Callback when a suggestion is added. */
  onAdd: (tag: SuggestedTag) => void;
};

/** Displays suggested tags as clickable ghost chips. */
export function SuggestedTagChips({
  suggestions,
  onAdd,
}: SuggestedTagChipsProps): JSX.Element | null {
  if (suggestions.length === 0) return null;

  return (
    <FlexBox gap="100" alignItems="center" className={styles.container}>
      {suggestions.map((tag) => (
        <Tooltip key={tag.id} content="Click to apply tag">
          <Chip
            className={styles.ghostWrapper}
            onClick={() => onAdd(tag)}
            aria-label={`Click to add suggested tag ${tag.name}`}
          >
            {tag.color && (
              <span
                className={styles.colorDot}
                style={{ backgroundColor: tag.color }}
              />
            )}
            {tag.name}
            <Icon name="ai" size={16} className={styles.icon} />
          </Chip>
        </Tooltip>
      ))}
    </FlexBox>
  );
}
